export function parseEncounterIds(raw: string): string[] {
  return raw.split(/[\s,;]+/).filter(Boolean);
}
